var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#5200FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0793 11.6709C20.3071 11.8987 20.3071 12.268 20.0793 12.4958L14.246 18.3291C14.0182 18.557 13.6488 18.557 13.421 18.3291L10.5044 15.4125C10.2765 15.1847 10.2765 14.8153 10.5044 14.5875C10.7322 14.3597 11.1015 14.3597 11.3293 14.5875L13.8335 17.0917L19.2543 11.6709C19.4822 11.443 19.8515 11.443 20.0793 11.6709Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0a0de6d5788ef7a71c5266ded9c1aba2.svg";
export { ForwardRef as ReactComponent };